// @flow
import React, { Component } from 'react';
import { View } from 'react-native';

type Props = {};

class ChangeContactNumber extends Component<Props> {
  render() {
    return <View />;
  }
}

export default ChangeContactNumber;
